import React, {useContext, useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import AltNavbar from '../components/AltNavbar';
import {useNavigate} from "react-router-dom";
import {validateEmail} from "../services/authService";
import {useAppContext} from "../context/appContext";


const SignIn: React.FC = () => {
    const [credentials, setCredentials] = useState({email: '', password: ''});
    const navigate = useNavigate();
    const {dispatch, loginUser, state} = useAppContext();
    useEffect(() => {
        console.log("Customer state changed:", state.customer);
        if (state.customer) {
            navigate("/profile");
        }
    }, [state.customer, navigate]);

    const handleLogin = async () => {
        // Validate email
        if (!validateEmail(credentials.email)) {
            alert("Please enter a valid email address.");
            return;
        }

        try {
            const response = await loginUser(credentials.email, credentials.password);

            if (response.success) {
                console.log(response)
                dispatch({type: 'LOGIN', payload: response.data.customer});

            } else {
                // Display the error message returned from the loginUser function
                const errorMessage = response.error?.[0]?.message;
                alert(errorMessage || "An error occurred. Please try again.");
            }
        } catch (error) {
            console.error("Error during login:", error);
            alert("Unable to connect. Please check your internet connection and try again.");
        }
    };

    return (
        <>
            <AltNavbar/>

            <div className='card'>
                <div>
                    <div className="card-header">
                        <h3>Login</h3>
                    </div>
                    <div className="card-content">
                        <label htmlFor="email" id="email-label">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={credentials.email}
                            onChange={e => setCredentials(prev => ({...prev, email: e.target.value}))}
                        />

                        <label htmlFor="password" id="password-label">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={credentials.password}
                            onChange={e => setCredentials(prev => ({...prev, password: e.target.value}))}
                        />

                        <Button onClick={handleLogin} id="login">Login</Button>

                        <p className="hr-lines">Or</p>

                        <a href="/register"><input type="submit" value="Create Account" id="register"/></a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SignIn;
